module.exports = __webpack_public_path__ + "img/03_Sticker.2030a3bf.svg";